import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../api";
import type { GeneratorListResponse } from "../components/ObjectModals/GeneratorModal/GeneratorModal.types";
import urls from "../urls";
import { generatorSingleEndpointQueries } from "./useGeneratorSingleEndpoint";

interface UseGeneratorSingleEndpointListProps {
  siteId?: number;
  vermarktungsvertragCompanyId?: number;
  options?: Partial<UseQueryOptions<GeneratorListResponse>>;
}

export function useGeneratorSingleEndpointList({
  siteId,
  vermarktungsvertragCompanyId,
  options
}: UseGeneratorSingleEndpointListProps) {
  return useQuery({
    ...generatorSingleEndpointQueries.list({
      siteId,
      vermarktungsvertragCompanyId
    }),
    ...options
  });
}

export async function fetchGeneratorSingleEndpointList({
  siteId,
  vermarktungsvertragCompanyId
}: {
  siteId?: number;
  vermarktungsvertragCompanyId?: number;
}) {
  const response = await apiWithoutCamelization.get<GeneratorListResponse>(
    urls.apiWithoutCamelization.generatorSingleEndpointList(
      siteId,
      vermarktungsvertragCompanyId
    )
  );
  return response.data;
}
